import { useEffect } from 'react';

/**
 * Componente para convertir un logo a circular con fondo blanco
 */
const CircularLogo = ({ logoUrl, onGenerated, size = 100 }) => {
    useEffect(() => {
        if (!logoUrl) {
            onGenerated(null);
            return;
        }

        const convertToCircular = async () => {
            try {
                const img = new Image();
                img.crossOrigin = 'Anonymous';
                
                img.onload = () => {
                    try {
                        const canvas = document.createElement('canvas');
                        canvas.width = size;
                        canvas.height = size;
                        const ctx = canvas.getContext('2d');
                        
                        // Crear círculo de recorte
                        ctx.beginPath();
                        ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
                        ctx.closePath();
                        ctx.clip();
                        
                        // Fondo blanco
                        ctx.fillStyle = '#ffffff';
                        ctx.fillRect(0, 0, size, size);
                        
                        // Dibujar la imagen centrada y recortada en círculo
                        ctx.drawImage(img, 0, 0, size, size);
                        
                        // Convertir a PNG base64
                        const pngData = canvas.toDataURL('image/png');
                        onGenerated(pngData);
                    } catch (err) {
                        console.error('Error en canvas:', err);
                        onGenerated(null);
                    }
                };

                img.onerror = (err) => {
                    console.error('Error cargando logo:', logoUrl, err);
                    onGenerated(null);
                };

                img.src = logoUrl;
            } catch (error) {
                console.error('Error convirtiendo logo a circular:', error);
                onGenerated(null);
            }
        };

        convertToCircular();
    }, [logoUrl, size, onGenerated]);

    return null; // No renderiza nada visible
};

export default CircularLogo;
